module.exports = __webpack_public_path__ + "src/assets/fonts/Mohaji-Icons.4acb20.ttf";